export default function Section5() {
  return (
    <div className="w-full Section5 px-[20px] md:px-[30px] my-[4%] md:my-0 md:pt-[2%] block md:flex md:justify-evenly md:items-center">
      <div className="md:w-[36%] w-full mb-5 md:mb-0">
        <h2 className="md:text-[34px] text-[#DA2128] font-bold text-[24px] leading-[32px] md:leading-[41px] my-[0.67em] pb-[2%]">
          <span className="text-black">Why Choose</span> Mean3 For WooCommerce
          Development?
        </h2>
        <p className="text-base leading-[20px] pb-[1%] text-[#373737] mb-5 font-open">
          Although WooCommerce is a free plugin that can be quickly added to
          your WordPress website, the best way to ensure that it is installed
          and configured successfully is to hire a developer, such as the
          professionals at Mean3. This is especially crucial if you're starting
          from scratch with your website.
        </p>
        <p className="text-base leading-[20px] pb-[1%] text-[#373737] mb-5 font-open">
          <strong>Steps we take when building up your online store:</strong>
        </p>
        <ul className="w-full text-[12px] md:text-[14px] font-[500] pb-[10px] font-open text-[#535353]">
          <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
            Building your WordPress website
          </li>
          <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
            Customizing your WooCommerce store
          </li>
          <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
            Adding products
          </li>
          <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
            Setting up shipping options
          </li>
          <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
            Configuring conversion tracking
          </li>
          <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
            Set up third-party integrations
          </li>
          <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
            Optimizing product pages & images
          </li>
          <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
            Optimizing your site for search engines
          </li>
          <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
            Adding extensions
          </li>
        </ul>
        <div className="bt-cont"><a href="#woo-contact" className="bg-[#DA2128] font-bold rounded-[3px] text-[white] p-[10px_15px] inline-block">Request a Quote</a></div>
      </div>
      <div className="img-container"><img className="block object-cover w-full" src="../../../assets/woo-website.png"></img></div>
    </div>
  );
}
